(function (angular) {
  "use strict";

  angular.module("Toyota.Services").service("PricingSendToDealerAutofill", [
    "$filter",
    "localstorage",
    function ($filter, localstorage) {
      var exports = this;

      var LOCAL_STORAGE_KEY_ENQUIRY_TYPE = "pricing_send_to_dealer_autofill_pricing_enquiry_type";
      var LOCAL_STORAGE_KEY_FINANCE_MESSAGE = "pricing_send_to_dealer_autofill_finance_message";
      var LOCAL_STORAGE_KEY_FINANCE_DISCLAIMERS = "pricing_send_to_dealer_autofill_finance_disclaimers";
      var LOCAL_STORAGE_KEY_FINANCE_ANALYTICS_DETAILS = "pricing_send_to_dealer_autofill_finance_analytics_details";
      var LOCAL_STORAGE_KEY_VEHICLE_MODEL = "pricing_send_to_dealer_autofill_vehicle_model";

      exports.setEnquiryTypeToFinance = function () {
        localstorage.set(LOCAL_STORAGE_KEY_ENQUIRY_TYPE, "finance");
      };

      exports.setEnquiryTypeToCash = function () {
        localstorage.set(LOCAL_STORAGE_KEY_ENQUIRY_TYPE, "cash");
      };

      /**
       * updateFinanceDetails - updates Send to Dealer form message for finance pricing in localstorage
       *
       * @param {Object} details                 Details needed to construct form autofill message and related disclaimers
       * @param {string} details.messageTemplate A string containing {%placeholders%} for substituting the following params
       * @param {string} details.variantName     the current vehicle variant name
       * @param {string} details.materialCode    the current vehicle material code
       * @param {number} details.pricePerWeek    the calculated loan repayment per week
       * @param {number} details.loanRate        the selected loan interest rate, between 0.0 and 1.0 inclusive
       * @param {number} details.loanTerm        the selected loan term in years
       * @param {number} details.gfv             the calculated Guaranteed Future Value
       * @param {number} details.deposit         the selected deposit
       * @param {number} details.kmsPerYear
       * @param {number} details.balloon
       * @param {number} details.vehicleModel    the selected vehicle model
       * @param {Object[]} details.disclaimers   The list of disclaimers to display below the form, in Sitecore schema
       * @param {Object} analyticsDetails        Object containing vehicle details, for extending form submission analytics data
       */

      exports.updateFinanceDetails = function (details, analyticsDetails) {
        var disclaimerReference = "";
        angular.forEach(details.disclaimers, function (disclaimer) {
          disclaimerReference += disclaimer.title;
        });

        var substitutions = {
          "{%variantName%}": details.variantName,
          "{%materialCode%}": details.materialCode,
          "{%pricePerWeek%}": $filter("formatPrice")(details.pricePerWeek) + "/wk",
          "{%interestRate%}": $filter("formatPercentage")(details.loanRate, 2),
          "{%loanTerm%}": details.loanTerm + " year",
          "{%gfv%}": $filter("formatPrice")(details.gfv),
          "{%deposit%}": $filter("formatPrice")(details.deposit),
          "{%kmsPerYear%}": $filter("formatNumber")(details.kmsPerYear) + " km",
          "{%balloon%}": $filter("formatPercentage")(details.balloon),
          "{%disclaimerReference%}": disclaimerReference,
        };

        var message = details.messageTemplate;
        message = Object.keys(substitutions).reduce(function (message, key) {
          return message.replace(key, substitutions[key]);
        }, message);

        localstorage.set(LOCAL_STORAGE_KEY_FINANCE_MESSAGE, message);
        localstorage.set(LOCAL_STORAGE_KEY_FINANCE_DISCLAIMERS, JSON.stringify(details.disclaimers));
        localstorage.set(LOCAL_STORAGE_KEY_FINANCE_ANALYTICS_DETAILS, JSON.stringify(analyticsDetails));

        if (details.vehicleModel) {
          localstorage.set(LOCAL_STORAGE_KEY_VEHICLE_MODEL, details.vehicleModel);
        }
      };

      /**
       * clear - removes all Send to Dealer form autofill data from localStorage
       *
       * @return {void}
       */
      exports.clear = function () {
        localstorage.remove(LOCAL_STORAGE_KEY_ENQUIRY_TYPE);
        localstorage.remove(LOCAL_STORAGE_KEY_FINANCE_MESSAGE);
        localstorage.remove(LOCAL_STORAGE_KEY_FINANCE_DISCLAIMERS);
        localstorage.remove(LOCAL_STORAGE_KEY_FINANCE_ANALYTICS_DETAILS);
        localstorage.remove(LOCAL_STORAGE_KEY_VEHICLE_MODEL);
      };

      /**
       * get - retrieves the Send to Dealer form enquiry type and message from localStorage
       *
       * @return {object} stored obect based on local storage key
       */
      exports.get = function () {
        if (
          localstorage.exists(LOCAL_STORAGE_KEY_ENQUIRY_TYPE) &&
          localstorage.get(LOCAL_STORAGE_KEY_ENQUIRY_TYPE).val === "finance"
        ) {
          return {
            enquiryType: "Finance",
            message: localstorage.get(LOCAL_STORAGE_KEY_FINANCE_MESSAGE).val,
            disclaimers: JSON.parse(localstorage.get(LOCAL_STORAGE_KEY_FINANCE_DISCLAIMERS).val),
            analyticsDetails: JSON.parse(localstorage.get(LOCAL_STORAGE_KEY_FINANCE_ANALYTICS_DETAILS).val),
            vehicleModel: localstorage.exists(LOCAL_STORAGE_KEY_VEHICLE_MODEL)
              ? localstorage.get(LOCAL_STORAGE_KEY_VEHICLE_MODEL).val
              : null,
          };
        }

        if (
          localstorage.exists(LOCAL_STORAGE_KEY_ENQUIRY_TYPE) &&
          localstorage.get(LOCAL_STORAGE_KEY_ENQUIRY_TYPE).val === "cash"
        ) {
          return {
            enquiryType: "",
            message: null,
            disclaimers: null,
            analyticsDetails: null,
            vehicleModel: null,
          };
        }

        return null;
      };
    },
  ]);
})(window.angular);
